import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Modal from 'react-responsive-modal'
import { Capacitor } from '@capacitor/core'
import {
  APP_STORE_URL,
  FORCE_UPDATE_ERROR_MESSAGE,
  FORCE_UPDATE_ERROR_STATUS,
  PLAY_STORE_URL,
} from './constants'
import { generateErrorObject } from 'common/utils/generateErrorObject'
import './StoreRedirectionModal.less'

const isForceUpdateError = (error) => {
  const { statusCode, message } = generateErrorObject(error)
  return statusCode === FORCE_UPDATE_ERROR_STATUS && message === FORCE_UPDATE_ERROR_MESSAGE
}

const getStoreUrl = () => {
  const platform = Capacitor.getPlatform()
  return platform === 'android'
    ? PLAY_STORE_URL
    : APP_STORE_URL
}

const redirectToStore = async () => {
  if (!Capacitor.isNativePlatform()) return
  
  try {
      window.location.href = getStoreUrl()
  } catch (error) {
    console.error(error)
  }
}

const StoreRedirectionModal = () => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (isForceUpdateError(error)) {
          setOpen(true)
        }
        return Promise.reject(error)
      }
    )

    return () => axios.interceptors.response.eject(interceptorId)
  }, [])

  return (
    <Modal
      open={open}
      onClose={() => {}}
      showCloseIcon={false}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      focusTrapped
      center
      classNames={{
        overlay: 'store-redirection-modal__overlay',
        modal: 'store-redirection-modal',
      }}
    >
      <header className="store-redirection-modal__header">
        <h2 className="store-redirection-modal__title">Nueva versión disponible</h2>
      </header>
      <div className="store-redirection-modal__body">
        <p className="store-redirection-modal__description">
          Actualizá la app para seguir gestionando tus operaciones con todas las mejoras de esta versión.
        </p>
      </div>
      <footer className="store-redirection-modal__footer">
        <button type="button" className="store-redirection-modal__button" onClick={redirectToStore}>
          Ir a actualizar
        </button>
      </footer>
    </Modal>
  )
}

export default StoreRedirectionModal
